import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import tooltip from './directives/tooltip';
import RefreshModal from './components/RefreshModal.vue';

// Create the main app
const app = createApp(App);

// Register the tooltip directive globally
app.directive('tooltip', tooltip);

app.use(store);

// Apply the theme on page load
const savedTheme = localStorage.getItem("theme") || "light";
document.documentElement.setAttribute("data-bs-theme", savedTheme);
store.commit("setTheme", savedTheme);

setInterval(() => {
  store.commit('updateRefresh');
}, 60000); // updates every minute

// Capture the initial version from version.json
let currentVersion;
const base = process.env.VUE_APP_UNI_SERVER === 'True' ? '/pa036-hw/' : '/';
fetch(base+'version.json', { cache: 'no-store' })
  .then((response) => response.json())
  .then(({ version }) => {
    currentVersion = version;
  })
  .catch((error) => console.error('Error fetching initial version:', error));

// Mount the RefreshModal component programmatically
const refreshModalApp = createApp(RefreshModal);
const modalContainer = document.createElement('div');
document.body.appendChild(modalContainer);
const refreshModalInstance = refreshModalApp.mount(modalContainer);

// Show modal window to refresh when detect deployment changes
setInterval(async () => {
  try {
    const response = await fetch(base+'version.json', { cache: 'no-store' });
    if (response.ok) {
      const { version } = await response.json();
      if (currentVersion && version !== currentVersion) {
        // Display the refresh modal using the component method
        refreshModalInstance.show();
      }
    }
  } catch (error) {
    console.error('Error checking app version:', error);
  }
}, 30000); // Check every 30 seconds

// Rehydrate store with user data on page load
store.dispatch('fetchUser').then(() => {
  app.use(router);
  app.mount('#app');
}).catch(() => {
  app.use(router);
  app.mount('#app');
});
